import AnalysisService from '@/services/analysisservice'
import WarehouseService from '@/services/warehouseservice'
import Premiumservice from '@/services/premiumservice'

const state = {
  authenticated: !!localStorage.getItem('tokenSalmon'),
  signupResultCode: null,
  isShowModal: false,
  isShowMaintenanceModal: false,
  maintenanceExp: null,
  isShowVerifyPaymentModal: false,
  verifyPaymentCheckoutUrl: '',
  paymentMethodRegistExp: '',
  paymentRedirectPath: null,
  modalMessage: null,
  modalWidth: 400,
  analysisMenu: [],
  premiumMenu: [],
  wareHouseIcons: {
    'Amazon': 'https://www.amazon.co.jp/favicon.ico',
    'salmonYamato': 'https://www.kuronekoyamato.co.jp/app-files/img/symbol/favicon.ico',
    'salmonAcross': 'https://across-logi.com/assets/images/favicon.svg',
    'salmonSc': 'https://image-yoshino.sakura.ne.jp/monster/StockCrew.png'
  }
}

const mutations = {
  doAuthenticated (state, success) {
    state.authenticated = success
  },
  saveResultCode (state, code) {
    state.signupResultCode = code
  },
  toggleModal (state, data = {}) {
    state.isShowModal = data.show || false
    state.modalMessage = data.show ? data.message : null
    state.modalWidth = data.modalWidth ? data.modalWidth : 400
  },
  toggleMaintenanceModal (state, data = {}) {
    state.isShowMaintenanceModal = data.show || false
    state.maintenanceExp = data.maintenanceExp || null
  },
  toggleVerifyPaymentModal (state, data = {}) {
    state.isShowVerifyPaymentModal = data.show || false
    state.verifyPaymentCheckoutUrl = data.show ? data.verifyPaymentCheckoutUrl : ''
    state.paymentMethodRegistExp = data.show ? data.paymentMethodRegistExp : ''
    state.paymentRedirectPath = data.paymentRedirectPath || null
  },
  setAnalysisMenu (state, data = []) {
    state.analysisMenu = data
  },
  setPremiumMenu (state, data = []) {
    state.premiumMenu = data
  },
  setWareHouseIcons (state, data = {}) {
    state.wareHouseIcons = data
  }
}

// getters
const getters = {
  isAuthenticated: state => state.authenticated,
  getResultCode: state => state.signupResultCode,
  getIsShowModal: state => state.isShowModal,
  getIsShowMaintenanceModal: state => state.isShowMaintenanceModal,
  getMaintenanceExp: state => state.maintenanceExp,
  getIsShowVerifyPaymentModal: state => state.isShowVerifyPaymentModal,
  getVerifyPaymentData: state => {
    return {
      verifyPaymentCheckoutUrl: state.verifyPaymentCheckoutUrl,
      paymentMethodRegistExp: state.paymentMethodRegistExp,
      paymentRedirectPath: state.paymentRedirectPath
    }
  },
  getPaymentMethodRegistExp: state => state.paymentMethodRegistExp,
  getModalMessage: state => state.modalMessage,
  getModalWidth: state => state.modalWidth,
  getAnalysisMenu: state => state.analysisMenu,
  getPremiumMenu: state => state.premiumMenu,
  getWareHouseIcons: state => state.wareHouseIcons
}

const actions = {
  fetchAnalysisMenu (context) {
    AnalysisService.getSubMenu()
      .then(response => {
        context.commit('setAnalysisMenu', response.data)
      })
  },
  fetchPremiumMenu (context) {
    Premiumservice.getAll()
      .then(response => {
        context.commit('setPremiumMenu', response.data)
      })
  },
  fetchWareHouseIcons (context) {
    WarehouseService.getWarehouseIcon()
      .then(response => {
        context.commit('setWareHouseIcons', response.data)
      })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js